import * as React from 'react'
import styled from 'styled-components'
import * as PropTypes from 'prop-types'
import cardErrorIcon from '../../../assets/img/card-linking/card-error-icon.png'

const ErrorCardMessageContainer = styled.div`
  margin: 0 1.1875rem 1rem 1.1875rem;
  font-size: 0.75rem;
  display: flex;
  background: #eaf1f9;
  border-radius: 5px;
  padding: 1rem;
  cursor: pointer;
`
const ErrorCardIcon = styled.img.attrs({ src: cardErrorIcon })`
  width: 3.5rem;
  object-fit: contain;
`

const ErrorCardMessage = styled.div`
  flex: 1;
  margin-left: 1rem;
  color: var(--color-fg-light);
`

const errorTypes = {
  internet: '201',
  os: '301',
  mrs: '401',
}

const CardsError = ({ display, errorType, onRetry, ...restofProps }) => {
  return display ? (
    <ErrorCardMessageContainer onClick={onRetry} {...restofProps}>
      <ErrorCardIcon />
      <ErrorCardMessage>
        {errorTypes[errorType] ? `(${errorTypes[errorType]})` : ''} We’re unable
        to load your linked card/s at the moment. Tap to retry after a few
        minutes.
      </ErrorCardMessage>
    </ErrorCardMessageContainer>
  ) : (
    <></>
  )
}

CardsError.defaultProps = {
  display: false,
  errorType: '',
}

CardsError.propTypes = {
  display: PropTypes.bool,
  errorType: PropTypes.string,
}

export default CardsError
